<!-- prettier-ignore -->
<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.05476 24V4.49776H2V0H22L20.6045 4.49776H14.2283V24H9.05476V24Z" />
  </svg>
</template>
